import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import * as Sentry from "@sentry/react";

import { AuthContext } from "features/Auth";

const SentryRoute = Sentry.withSentryRouting(Route);

export const ROUTES_WHITElIST = [
    "/dashboard",
    "/login",
    "/register",
    "/404-page-not-found",
    "/updates",
    "/code-library",
    "/upgrade-library",
    "/generate-report",
    "/legacy-parametric-analysis",
    "/parametric-analysis",
    "/communities/dashboard",
    "/communities",
    "/resources/quickstart",
    "/resources/faqs",
    "/resources/contact",
    "/resources/roadmap",
    "/resources/terms",
    "/resources/privacy",
    "/resources/licence",
    "/user/preferences",
    "/user/account",
    "/user/organization",
    "/create",
    "/models",
    "/communities",
    "/password-reset",
    "/password-reset/new-password",
    "/action-redirect",
    "/pricing",
];

export const makeIsActive = (pathname, basePath) => (url) => {
    const fullPath = `${basePath}${url}`.replace(/\/+$/, ""); // strip trailing slash
    const current = pathname.replace(/\/+$/, "");

    // Special case for default tab (`/`)
    if (url === "/" || url === "") {
        return current === basePath.replace(/\/+$/, "");
    }

    // Match exact or nested
    return current.startsWith(fullPath);
};

export const PrivateRoute = ({ component: RouteComponent, ...rest }) => {
    const { user, pending } = useContext(AuthContext);

    if (pending) return null;

    return (
        <SentryRoute
            {...rest}
            render={(routeProps) => (!!user ? <RouteComponent {...routeProps} /> : <Redirect to="/login" />)}
        />
    );
};
